import {useState} from 'react'
import {PageLink, PageTitle} from '../../_metronic/layout/core'
import {TContractTermRequest} from '../../coreGlobal/models/admin/contractTerm'
import {useFormik} from 'formik'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {createContractTerm} from './core/_request'
import {contractTermSchema} from './core/validation/ContractTermsVali'
import {ContractTermForm} from './components/ContractTermForm'

const ContractTermBreadcrumbs: Array<PageLink> = [
  {
    title: 'Admin',
    path: '/admin/contract-terms',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const Create = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const [contractTermInitialValues] = useState<TContractTermRequest>({
    name: '',
    description: '',
    content: '',
  })

  const formik = useFormik({
    initialValues: contractTermInitialValues,
    validationSchema: contractTermSchema,
    onSubmit: async (values) => {
      submit(values)
    },
  })

  const submit = async (req: TContractTermRequest) => {
    await Swal.fire({
      title: 'Deseja adicionar o termo?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true)
        try {
          await createContractTerm(req)
          await Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Termo adicionado com sucesso',
            showConfirmButton: false,
            timer: 1500,
          })

          navigate('/admin/contract-terms', {replace: true})
        } catch (error: any) {
          if (error.response.status === 422) {
            let errorText = ''
            for (let key in error.response.data.errors) {
              errorText += '<li>' + error.response.data.errors[key][0] + '</li>'
            }
            await Swal.fire({
              icon: 'error',
              title: 'Ops! Revise seu formulário e tente novamente!',
              html: errorText,
            })
          } else {
            await Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.message,
              timer: 2000,
            })
          }
        } finally {
          setLoading(false)
        }
      }
    })
  }

  return <ContractTermForm formik={formik} loading={loading} />
}

export const ContractTermCreatePage = () => {
  return (
    <>
      <PageTitle breadcrumbs={ContractTermBreadcrumbs}>Adicionar Termo</PageTitle>
      <Create />
    </>
  )
}
